module.exports = __webpack_public_path__ + "static/img/25.827cb50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/25.jpg
// module id = R7Y0
// module chunks = 0